import YFormLabel from './Label';

export { YFormLabel };
export default YFormLabel;
